export interface ISmartUploadProcess {
  upload_id: string;
  application_id: string | null;
  filenames: string[];
  status: SmartUploadProcessStatus;
}

export enum TxStatus {
  SubmissionInProgress = 'Submission_in_progress',
  Scheduled = 'Scheduled',
  Started = 'Started',
  Completed = 'Completed',
  TimedOut = 'TimedOut',
  Failed = 'Failed',
}

export enum SmartUploadProcessStatus {
  Submitted = 'Submitted',
  Extracting = 'Extracting',
  Processing = 'Processing',
  Enriching = 'Enriching',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface IUniversalSubmit {
  submission_id: string;
  submission_status: string;
  tenant_id: string;
  user_id: string;
  application_id: string;
  application_status: string;
  application_status_reason: string;
  tx_status: TxStatus;
}
export interface IInsuranceIntelligence {
  submission_id: string;
  submission_status: string;
  tenant_id: string;
  user_id: string;
  quote_application?: {
    tx_status: TxStatus;
    tx_id: string;
    application_id?: string;
  };
  document_processing: {
    tx_status: TxStatus;
  };
}

export interface IInProgressUpload {
  id: string;
  tenant_id: string;
  owner_id: string;
  tx_id: string;
  created_at: string;
  updated_at: string;
  status: string;
  files: string[];
}

export const validFileTypes = [
  'application/pdf',
  'image/*',
  'text/plain',
  'application/json',
  'application/zip',
].join(',');
